import React from "react";
import { Callout, ControlGroup, Tag, Tooltip } from "@blueprintjs/core";
import { Trans, withTranslation } from "react-i18next";
import { w3cwebsocket as W3CWebSocket } from "websocket";

import { authenticatedGetFetch, getBackendRoute } from "../../utils/AuthenticatedFetch";
import Title from "../Structure/logo";
import Endpoint from "./Endpoint";
import AddEndpoint from "./AddEndpoint";
import CallPlannings from "./CallPlannings";
import Contacts from "./Contacts";
import Trunk from "./Trunk";
import TestSound from "./TestSound";

class Phonie extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: undefined,
      CompleteAdd: false,
      client: false,
    };
  }

  componentDidMount() {
    this.setState({ client: true });
    // get list of endpoints from server
    authenticatedGetFetch("/phonie/endpoints", (endpoints) => {
      this.setState({ endpoints: endpoints }, () => {
        this.client = new W3CWebSocket(
          getBackendRoute("WS") + "/phonie/rt/endpoints",
          ["Bearer", localStorage.getItem("token")]
        );
        this.client.onerror = (error) => console.error(error);
        this.client.onclose = () => {
          console.log(
            "WebSocket phonie Client Disonnected, retry in 2 seconds"
          );
          setTimeout(() => {
            this.client = new W3CWebSocket(
              getBackendRoute("WS") + "/phonie/rt/endpoints",
              ["Bearer", localStorage.getItem("token")]
            );
            console.log("WebSocket phonie Client reconnected");
          }, 2000);
        };
        this.client.onmessage = (message) => {
          try {
            // Permite to add only new state when there is a changment
            const new_state = JSON.parse(message.data);
            const state = new_state.state;
            const name = new_state.name;
            const in_call_with = new_state.in_call_with;
            const ip = new_state.ip;
            const type = new_state.type;
            const equipment = new_state.equipment;
            const equipment_name = new_state.equipment_name;
            if (name !== undefined && state !== undefined) {
              const new_state = this.state.endpoints;
              new_state[name] = {
                name: name,
                state: state,
                in_call_with: in_call_with,
                ip: ip,
                type: type,
                equipment: equipment,
                equipment_name: equipment_name,
              };
              this.setState({ endpoints: new_state });
            }
          } catch (e) {
            console.error("Error while parsing " + JSON.stringify(message));
          }
        };
      });
    });
    authenticatedGetFetch("/phonie/trunkinfo", (trunk) =>
      this.setState({ trunk: trunk })
    );
  }

  componentWillUnmount() {
    if (this.client) this.client.close();
    this.setState({ client: false });
  }

  shouldComponentUpdate(nextProps, nextState) {
    return this.state.client;
  }

  render() {
    const endpoints = [];
    for (const endpoint in this.state.endpoints)
      if (
        this.state.endpoints[endpoint]["name"] !== "webrtc_client" &&
        this.state.endpoints[endpoint]["name"] !== "trunk-ovh"
      )
        endpoints.push(
          <Endpoint
            key={endpoint}
            {...this.state.endpoints[endpoint]}
            onDelete={() => {
              authenticatedGetFetch("/phonie/endpoints", (endpoints) => {
                this.setState({ endpoints: endpoints });
              });
            }}
          />
        );

    return (
      <div>
        <div className="component-body">
          <Title icon="phone" text="phonie" />
          <Callout icon="phone" title={<Trans>intercom terminals</Trans>}>
            <div>
              <ControlGroup>
                {localStorage.getItem("perm_superadmin") === "true" && (
                  <AddEndpoint />
                )}
                {localStorage.getItem("perm_superadmin") === "true" && (
                  <Trunk
                    trunk={this.state.trunk}
                    update={(info) => this.setState({ trunk: info })}
                  />
                )}
                {this.state.trunk &&
                  localStorage.getItem("perm_admin") === "true" && (
                    <Contacts />
                  )}
                {!this.state.trunk &&
                  localStorage.getItem("perm_superadmin") === "true" && (
                    <Tooltip
                      content={
                        <Trans>
                          you must configure a SIP trunk to access this tab
                        </Trans>
                      }
                    >
                      <Tag large={true} round={true} icon="new-person" />
                    </Tooltip>
                  )}
                {this.state.trunk &&
                  localStorage.getItem("perm_admin") === "true" && (
                    <CallPlannings />
                  )}
                {!this.state.trunk &&
                  localStorage.getItem("perm_superadmin") === "true" && (
                    <Tooltip
                      content={
                        <Trans>
                          you must configure a SIP trunk to access this tab
                        </Trans>
                      }
                    >
                      <Tag large={true} round={true} icon="calendar" />
                    </Tooltip>
                  )}
                <TestSound />
              </ControlGroup>
              <div className="flexbox-left">{endpoints}</div>
            </div>
          </Callout>
        </div>
      </div>
    );
  }
}

export default withTranslation()(Phonie);
